import { Route, Routes } from 'react-router-dom';

import Unit from './don-vi-tinh';
import Product from './hang-hoa-dich-vu';
import Petrolimex from './hang-hoa-xang-dau';
import Device from './thiet-bi';
import IntegrationDevice from './thiet-bi-tich-hop';
import PetrolimexLog from './danh-sach-giao-dich-xang-dau';
import TenantClient from './khach-hang';
import EmailTemplate from './mau-email';
import Tax from './thue-suat';
import Currency from './tien-te';
import PaymentType from './ht-thanh-toan';
import { PrivateRoute } from '../components/PrivateRoute';
import StoreService from './cua-hang-xang-dau';
import { ROLE } from '../../Constant';
import NganHangThuHuongTemplate from './ngan-hang-thu-huong';

export default function Category() {

  return (
    <Routes>
      <Route path="don-vi-tinh/*" element={<PrivateRoute role={ROLE.CATEGORY_UNIT} parentRole={true}> <Unit /></PrivateRoute>} />
      <Route path="hang-hoa-dich-vu/*" element={<Product />} />
      <Route path="hang-hoa-xang-dau/*" element={<Petrolimex />} />
      <Route path="thiet-bi/*" element={<Device />} />
      <Route path="thiet-bi-tich-hop/*" element={<IntegrationDevice />} />
      <Route path="khach-hang/*" element={<TenantClient />} />
      <Route path="mau-email/*" element={<EmailTemplate />} />
      <Route path="thue-suat/*" element={<Tax />} />
      <Route path="tien-te/*" element={<Currency />} />
      <Route path="ht-thanh-toan/*" element={<PaymentType />} />
      <Route path="danh-sach-giao-dich-xang-dau/*" element={<PetrolimexLog />} />
      <Route path="cua-hang-xang-dau/*" element={<StoreService />} />
      <Route path="ngan-hang-thu-huong/*" element={<NganHangThuHuongTemplate />} />
    </Routes>
  );
}
